import { useState } from "react";
import instance from "~/utils/i18n";
import { Switch } from "~/common/components/Switch/Switch";

const originalLanguage = window.SCHA.config.language;

export const DebugLanguageToggle = () => {
  const [debugEnabled, setDebugEnabled] = useState(false);

  return (
    <div className="scha__header__language-toggle">
      <Switch
        checked={debugEnabled}
        onChange={(event, value) => {
          setDebugEnabled(value);
          instance.changeLanguage(value ? "cimode" : originalLanguage);
        }}
      />
    </div>
  );
};
